// extracted by mini-css-extract-plugin
export var dialog_modal = "modal-module--dialog_modal--4d9b1";
export var modalFadeIn = "modal-module--modalFadeIn--92c2b";
export var modalSlideUp = "modal-module--modalSlideUp--bbdf2";
export var modal_body = "modal-module--modal_body--c2df5";
export var modal_close = "modal-module--modal_close--ba6db";
export var modal_color_hex = "modal-module--modal_color_hex--26a98";
export var modal_color_info = "modal-module--modal_color_info--e24d7";
export var modal_color_name = "modal-module--modal_color_name--68a09";
export var modal_color_preview = "modal-module--modal_color_preview--766e4";
export var modal_copy_btn = "modal-module--modal_copy_btn--d8d64";
export var modal_header = "modal-module--modal_header--082b9";
export var modal_header_actions = "modal-module--modal_header_actions--337ed";
export var modal_header_left = "modal-module--modal_header_left--1b549";
export var modal_toast = "modal-module--modal_toast--f513a";
export var modal_wrapper = "modal-module--modal_wrapper--0067c";
export var scroll_indicator = "modal-module--scroll_indicator--bbb4d";
export var toastSlideUp = "modal-module--toastSlideUp--d62a4";
export var visible = "modal-module--visible--94a26";